import { render } from "./AudioController.vue?vue&type=template&id=a9c79254"
import script from "./AudioController.vue?vue&type=script&lang=js"
export * from "./AudioController.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__